const boundFunctions = new Map();

const addListener = (el, binding) => {
    if (!binding.value) {
        return;
    }

    const confirm = e => {
        if (!window.confirm(binding.value)) {
            e.preventDefault();
        }
    };

    el.addEventListener(binding.arg || 'click', confirm);
    boundFunctions.set(el, confirm);
};

const clearListener = (el, binding) => {
    if (boundFunctions.has(el)) {
        el.removeEventListener(binding.arg || 'click', boundFunctions.get(el));
        boundFunctions.delete(el);
    }
};

export default {
    bind(el, binding, vnode) {
        addListener(el, binding);
    },

    update(el, binding) {
        clearListener(el, binding);
        addListener(el, binding);
    },

    unbind(el, binding) {
        clearListener(el, binding);
    }
}
